"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Fieldset = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("../utils/constants");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Fieldset = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Fieldset.css") : void 0);
var _excluded = ["children", "className", "classicFieldset", "disabled", "formId", "hideLegend", "legend", "legendProps", "muted"];
var CSS_BLOCK = 'sapcnqr-fieldset';

/**
 * **Fieldset** is used to give semantic meaning to a group of elements
 * inside a form (_e.g._ Billing or Shipping Address).
 * Grouping fields together into a **Fieldset** also provides styling and accessibility benefits.
 */
var Fieldset = exports.Fieldset = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    classicFieldset = props.classicFieldset,
    disabled = props.disabled,
    formId = props.formId,
    hideLegend = props.hideLegend,
    legend = props.legend,
    legendProps = props.legendProps,
    muted = props.muted,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_Fieldset.default);
  var classes = classnames(className, _constants.CSS_PREFIX, CSS_BLOCK, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--classic"), classicFieldset && !muted), "".concat(CSS_BLOCK, "--muted"), muted), "".concat(CSS_BLOCK, "--no-legend"), hideLegend));
  var legendClasses = classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__legend"), legendProps === null || legendProps === void 0 ? void 0 : legendProps.className, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "--screen-reader-only"), hideLegend));
  var addChildProps = function addChildProps(child, childProps) {
    var componentsThatCanBeDisabled = ['Button', 'Checkbox', 'Link', 'Radio', 'Tab'];
    var componentsThatCanBeDisabledAndSupportLayout = ['DatePicker', 'DateInputField', 'DateSelect', 'DateRangeSelect', 'InputField', 'RadioGroup', 'Select', 'TimePicker', 'Slider', 'TextArea'];
    if (componentsThatCanBeDisabled.indexOf(child.displayName) !== -1) {
      return {
        disabled: !!disabled || childProps.disabled
      };
    }
    if (componentsThatCanBeDisabledAndSupportLayout.indexOf(child.displayName) !== -1) {
      return {
        disabled: !!disabled || childProps.disabled
      };
    }
    return {};
  };
  return /*#__PURE__*/_react.default.createElement("fieldset", (0, _extends2.default)({}, otherProps, {
    className: classes,
    disabled: disabled,
    form: formId,
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("legend", (0, _extends2.default)({}, legendProps, {
    className: legendClasses
  }), legend), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: addChildProps
  }, children));
});
Fieldset.displayName = 'Fieldset';
Fieldset.propTypes = {
  /** Text placed at the top of the **Fieldset** to identify group content. */
  legend: _propTypes.default.node.isRequired,
  /** A collection of elements that are to be contained within the **Fieldset**. */
  children: _propTypes.default.node,
  /** Set to `true` to use classic **Fieldset** styling. */
  classicFieldset: _propTypes.default.bool,
  /** Any custom classes to add to the `<fieldset>` element. */
  className: _propTypes.default.string,
  /** Sets the `disabled` attribute on the `<fieldset>` element.
   * It also disables any inputs, links, buttons or select controls
   * within that **Fieldset** by setting appropriate HTML attributes, i.e.
   * `disabled` or `aria-disabled`, on them. */
  disabled: _propTypes.default.bool,
  /** Relates the **Fieldset** to the parent form based on id. */
  formId: _propTypes.default.string,
  /** Set to `true` to hide the **Fieldset** legend. Hiding the legend only hides
   * it visually -- it is still used for accessibility reasons. */
  hideLegend: _propTypes.default.bool,
  /** Sets the `id` attribute on the `<fieldset>` element. */
  id: _propTypes.default.string,
  /** Additional props to spread to the `<legend>` element. */
  legendProps: _propTypes.default.object,
  /** Set to `true` to use muted **Fieldset** styling. */
  muted: _propTypes.default.bool,
  /** Sets the `name` attribute on the `<fieldset>` element. */
  name: _propTypes.default.string
};
var _default = exports.default = Fieldset;